import _regeneratorRuntime from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import axios from "./axios";
import { storeInstance } from "../store";
export default
/*#__PURE__*/
(function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref.Vue;
            Vue.prototype.$axios = axios;
            storeInstance.dispatch('initLoginStateTracker');
            storeInstance.dispatch('initMeasuresTracker');
            storeInstance.dispatch('initLandTracker');
            storeInstance.dispatch('initNoticesTracker');
            storeInstance.dispatch('initUserDataTracker');
            storeInstance.dispatch('initKVTracker');

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})(); // storeInstance.dispatch('initConnectedStateTracker')
// storeInstance.dispatch('initAdvertsTracker')
// storeInstance.dispatch('initGebiedTracker')